import {GET_SEARCH_RESULT_REFINER_DATA, PAGE_LEVEL_REFINER, SEARCH_BASED_REFINERS} from '../../constants/reducerTypes';

const initialState = {pageLevelRefiners: {}}
const refinerReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAGE_LEVEL_REFINER:
            return {
                ...state,
                pageLevelRefiners: action.payload
            };
        case SEARCH_BASED_REFINERS:
            return {
                ...state,
                searchRefiners: action.payload
            };
        case GET_SEARCH_RESULT_REFINER_DATA:
            return {
                ...state,
                searchResultRefiner: action.payload
            };
        default:
            return state;
    }
};
export default refinerReducer;
